query GetAmendedPledges(
  $page: Int
  $limit: Int
  $search: String
  $status: PledgeSearchEnum!
) {
  amendedPledges(page: $page, limit: $limit, search: $search, status: $status) {
    collection {
      id
      firstName
      surname
      userId
      createdDate
      fullHomeAddress
      companyName
      currentPercentage
      dateSigned
      countersigned
      originalPercentage
      originalDateSigned
      signed
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
